import {confirmAlert} from "react-confirm-alert";
import React from "react";
import DeleteDialog from "../../../../components/DeleteDialog";
import {deleteNotes} from "../../../../api";
import Card from "antd/es/card";

const bodyStyle = {
    margin: "1.5rem"
}

const DeleteMeetingNoteDialogBody = ({note}) => (
    <div style={bodyStyle}>
        <div>Are you sure you want to delete this meeting note?</div>
        <Card className="meeting-note-delete-dialog">
            <div><b>Meeting Type:</b> {note.meetingType}</div>
            <div><b>Date:</b> {note.meetingDate}</div>
            <div><b>Location:</b> {note.meetingLocation}</div>
        </Card>
    </div>
);

const ShowDeleteMeetingNoteDialog = (projectId, note, handleRefreshCall) => {

    const options = {
        closeOnEscape: true,
        customUI: ({ onClose }) => <DeleteDialog
            onClose={ onClose }
            onAccept={ async () => {
                await deleteNotes(projectId, note.id);
                handleRefreshCall();
                onClose();
            }}
            body={<DeleteMeetingNoteDialogBody note={note} />}
        />
    };

    confirmAlert(options);
};


export default ShowDeleteMeetingNoteDialog;